// The phone form is '/' — there is no /phone page, despite the branch for
// one in getLoginVariantFromUrl, which is dead code. That is the whole
// reason /email's "sign in with a phone number" link was a round trip: it
// pointed at '/', which is exactly where getRedirect intercepts a UK pupil
// and sends them back to their school's door. DEV-727 hid the link. This
// makes it work instead, because the pilot wants every way in reachable.
//
// Producer and consumer live here together on purpose. The link is built
// in pages/email.tsx and the flag is read in pages/_app.tsx, and a pair
// like that has already drifted apart once in this flow — the door cookie
// was written against one field and read against another, which produced
// a redirect loop that took two attempts to find.
//
// A predicate rather than a bare constant, for a duller reason. The
// getRedirect suite mocks utils/constants with an explicit list of keys;
// an omitted string constant comes back undefined and `undefined ===
// undefined` is true, which would silently disable every door in the
// tests while they stayed green. A missing function throws instead.
export const PHONE_FORM_HREF = '/?login=phone';

export const isPhoneFormRequest = (query?: {
  [key: string]: string | string[] | undefined;
}): boolean => query?.login === 'phone';
